
angular.module('trainerWebApp.resources').factory('ShopifyResolver',
  ['$q', '$route', 'shopifyResource', 'Validation', 'errorHandler', 'refreshSession', 'Auth', 'mtypes', function ($q, $route, shopifyResource, Validation, errorHandler, refreshSession, Auth, mtypes) {

    function normalizeTypes(items) {
      if(!items || items.length === 0) return [];
      for (var i = 0, c = items.length; i < c; i++) {
        items[i].type = items[i].type === mtypes.courseType.series ? 'Series' : 'Course';
      }
      return items;
    }

    function addSeriesThumbUrls(items) {
      if(!items || items.length === 0) return [];
      for (var i = 0, c = items.length; i < c; i++) {
        if(items[i].type === 'Series')
          items[i].thumbUrl = 'images/home/tn_series.png';
      }
      return items;
    }

    return function () {
      var deferred = $q.defer();
      var pageName = $route.current.params.pageName || $route.current.pageName;

      var successCb = function (result) {
        Auth.getRolePromise().then(function() {
          deferred.resolve(result);
        });
      };

      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      if (!pageName || pageName == 'manageShopifyCourses') {
        refreshSession.refresh(null, function() {
          shopifyResource.load(function(shopifyInfo) {
            shopifyInfo.items = addSeriesThumbUrls(normalizeTypes(shopifyInfo.items));
            successCb(shopifyInfo);
          }, errorHandler.defaultServerErrorHandler());
        });
      } else if (pageName == 'addShopifyCourses') {
        refreshSession.refresh(null, function() {
          shopifyResource.allCourses(function(addContentSetup) {
            addContentSetup.availableItems = addSeriesThumbUrls(normalizeTypes(addContentSetup.items));
            successCb(addContentSetup);
          }, errorHandler.defaultServerErrorHandler());
        });
      }

      return deferred.promise;
    };
  }]
);
